import { GetHomepageTabPageArgs } from 'types/api/arguments/get-homepage-tab-page-args'
import { HomepageTabResp } from 'types/api/response/homepage-tab-resp'

import { api } from './api'

export const getHomepageTab = (args: GetHomepageTabPageArgs) =>
  api.get<HomepageTabResp>(`/homepage/${args.tabName}`, {
    params: {
      next_page_token: args.nextPageToken,
      homepage_session_id: args.homepageSessionId,
      column_count: args.columnCount,
      version: 3,
    },
  })
